module.exports = __webpack_public_path__ + "img/like-small.80e7ae9e.svg";